import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import styles from "@/styles/Video.module.scss";
import { useCallback } from "react";

export default function EntitlementConfirm({ state }) {
  const handleCancel = useCallback(() => {
    state.prepareReconfirm();
  }, []);
  const handleConfirm = useCallback(() => {
    state.entitlementConfirm();
  }, []);

  return (
    <div className={styles.entitlement}>
      <div className={styles.message}>
        <p>
          ご購入ありがとうございます。
          <br />
          視聴可能期間をご確認いただき、ご視聴をお楽しみください。
        </p>
      </div>
      <div className={styles.buttons}>
        <ButtonMultiClick
          fillColor
          medium
          fillGray
          borderGray
          onClick={handleCancel}
        >
          キャンセル
        </ButtonMultiClick>
        <ButtonMultiClick fillColor medium onClick={handleConfirm}>
          再生する
        </ButtonMultiClick>
      </div>
    </div>
  );
}
